export const randomColor = () =>
  colors[getRandomInt(colors.length)]

const colors = ['#96CEB4', '#FF5733', '#FF6F68', '#FFCC5C', '#A7D59C']

const getRandomInt = max =>
  Math.floor(Math.random() * Math.floor(max))
